module.exports = __webpack_public_path__ + "static/img/kwh_item_image1.195e03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/kwh_item_image1.png
// module id = Vird
// module chunks = 1